import { ApiPutRequest } from './api-put-request';
import { ApiParameters } from './api-parameters';

export class RecurringBsPaymentRequest extends ApiPutRequest
{
    public constructor(
        orderId: number,
        bsId: number,
        webapiBasepath: string
    )
    {
        super(  'v2/RecurringBsSale', 
                new ApiParameters(), 
                null, 
                {
                    orderId,
                    bsId
                },
                webapiBasepath
            );
    }
}
